import { Loader } from '@fountain/fountain-ui-components';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { addMessageAction } from 'containers/FlashMessage/actions';
import globalMessages from 'shared/global/messages';

import { deleteAgent } from '../../api';
import { messages } from '../../messages';
import { AxAgentResponse } from '../../types';
import { useConfirmationModalStyles } from '../styles';

interface DeleteAgentConfirmationModalProps {
  handleClose: () => void;
  currentAgentId?: string;
  openConfirmDialog: boolean;
  setOpenConfirmDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setRefreshToken: React.Dispatch<React.SetStateAction<boolean>>;
  setAgents: React.Dispatch<React.SetStateAction<AxAgentResponse[]>>;
  accountSlug: string;
}

export const DeleteAgentConfirmationModal: React.FC<
  DeleteAgentConfirmationModalProps
> = ({
  handleClose,
  currentAgentId,
  openConfirmDialog,
  setOpenConfirmDialog,
  setRefreshToken,
  setAgents,
  accountSlug,
}) => {
  const classes = useConfirmationModalStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);

  const confirmDelete = async () => {
    setIsLoading(true);
    try {
      await deleteAgent(accountSlug, currentAgentId as string);
      setAgents(prevAgents =>
        prevAgents.filter(agent => agent.uuid !== currentAgentId),
      );
      dispatch(
        addMessageAction(
          intl.formatMessage(messages.agentDeleteSuccess),
          'success',
        ),
      );
    } catch (err) {
      dispatch(
        addMessageAction(
          intl.formatMessage(messages.agentDeleteFailed),
          'error',
        ),
      );
    } finally {
      setIsLoading(false);
      setOpenConfirmDialog(false);
      setRefreshToken(true);
      handleClose();
    }
  };

  if (isLoading) return <Loader fullScreen size="2rem" />;

  return (
    <Dialog
      open={openConfirmDialog}
      onClose={() => setOpenConfirmDialog(false)}
      classes={{ paperScrollPaper: classes.modalContainer }}
    >
      <DialogTitle classes={{ root: classes.modalTitle }}>
        <FormattedMessage {...messages.deleteAiAgent} />
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <DialogContentText classes={{ root: classes.modalContentText }}>
          <FormattedMessage {...messages.deleteModalDescription} />
        </DialogContentText>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button
          onClick={() => {
            setOpenConfirmDialog(false);
            handleClose();
          }}
          color="default"
          variant="outlined"
          className={classes.btnCancel}
        >
          <FormattedMessage {...globalMessages.cancel} />
        </Button>
        <Button
          onClick={() => void confirmDelete()}
          color="secondary"
          variant="outlined"
          className={classes.btnDelete}
        >
          <FormattedMessage {...globalMessages.delete} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
